module.exports = __webpack_public_path__ + "media/images/athletes/3591-bf49da2633b4370414ac8f3a0900fb3c.png";